import { getKPIFormattedValue } from "PFApp/helpers/kpi_formatter";
import { KPIEvent, KPIStatus, KPIUnit as KPIUnitEnum } from "PFCore/types/kpi";
import { useTranslation } from "react-i18next";

import { isEvaluationErrorEvent, isSystemEvent } from "../kpi_event_tile.utils";

export const useEventText = (event: KPIEvent, KPIUnit: KPIUnitEnum) => {
  const { t } = useTranslation("activities", { keyPrefix: "KPIsReviewSidepanel" });
  const { value, status, comment } = event;

  if (isEvaluationErrorEvent(event)) {
    return t("kpiCouldntBeEvaluated");
  }

  if (isSystemEvent(event)) {
    return t(status === KPIStatus.OnTarget ? "valueIsInCompliantRange" : "valueIsNonCompliant", {
      value: getKPIFormattedValue(value, KPIUnit)
    });
  }

  return comment;
};
